module.exports = __webpack_public_path__ + "static/media/108c1.f3cb02e9.jpg";